import React, { memo } from 'react';
import { CheckBoxOutlineBlank, Check } from '@mui/icons-material';
import ComplexButton from './ComplexButton';
import Typography from '../../Typography';
import Box from 'component/layoutComponents/Box';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';

type WarrantyType = {
  isThreeYearsProtection: boolean;
  isAddSealedBatteryReplacement: boolean;
};

const WarrantyContent = ({
  warrantyValues,
  onClick,
  locale,
}: {
  warrantyValues: WarrantyType;
  onClick: (values: WarrantyType) => void;
  locale: any;
}) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;

  const handleClick = (values: WarrantyType) => {
    onClick(values);
  };

  return (
    <>
      <Typography variant="h6" color="text.primary">{locale?.productDetail?.warranty}</Typography>
      <Box paddingTop={`${theme.uptimeSpace[4]}px`} width="100%">
        <Box marginBottom={`${theme.uptimeSpace[6]}px`}>
          <ComplexButton
            checked={warrantyValues.isThreeYearsProtection}
            label={locale?.productDetail?.threeYearsProtection}
            icon={
              warrantyValues.isThreeYearsProtection ? (
                <Check htmlColor={theme.uptimeColors.generalColors.icon.enabled} />
              ) : (
                <CheckBoxOutlineBlank htmlColor={theme.uptimeColors.textColors.secondary} />
              )
            }
            detail={
              warrantyValues.isThreeYearsProtection
                ? 'Included'
                : ''
            }
            onClick={() =>
              handleClick({
                ...warrantyValues,
                isThreeYearsProtection: !warrantyValues.isThreeYearsProtection,
              })
            }
          />
        </Box>
        <Box marginBottom="12px">
          <ComplexButton
            checked={warrantyValues.isAddSealedBatteryReplacement}
            label={locale?.productDetail?.addSealedBatteryReplacement}
            icon={
              warrantyValues.isAddSealedBatteryReplacement ? (
                <Check htmlColor={theme.uptimeColors.mainTheme.primary} />
              ) : (
                <CheckBoxOutlineBlank htmlColor={theme.uptimeColors.textColors.secondary} />
              )
            }
            detail={
              warrantyValues.isAddSealedBatteryReplacement
                ? locale?.productDetail?.included
                : ''
            }
            onClick={() =>
              handleClick({
                ...warrantyValues,
                isAddSealedBatteryReplacement: !warrantyValues.isAddSealedBatteryReplacement,
              })
            }
          />
        </Box>
      </Box>
    </>
  );
};

export default memo(WarrantyContent);
